// store/modules/sessionReservation.js
const state = {
  sessionModal: false,
  chosenCourse: null,
  sessionType: null,
}

const getters = {
  getSessionModal(state) {
    return state.sessionModal
  },
  getChosenCourse(state) {
    return state.chosenCourse
  },
  getSessionType(state) {
    return state.sessionType
  },
}

const mutations = {
  setChosenCourse(state, payload) {
    state.chosenCourse = payload
  },
  setSessionModal(state, payload) {
    state.sessionModal = payload
  },
  setSessionType(state, payload) {
    state.sessionType = payload
  },
}

const actions = {
  /**
   * Commit fetched courses to the store.
   * @param {Function} commit
   * @param {Array} payload - Courses array
   */
  setSessionModal({ commit }, payload) {
    commit("setSessionModal", payload)
  },
  setChosenCourse({ commit }, payload) {
    commit("setChosenCourse", payload)
  },
  setSessionType({ commit }, payload) {
    commit("setSessionType", payload)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
